/**
 * Physical and astronomical constants for orbital mechanics.
 *
 * Units: km, km/s, km^3/s^2, radians unless otherwise noted.
 */

/** Standard gravity (m/s^2) */
export const G0 = 9.80665;

/** Speed of light (m/s) */
export const C = 299792458.0;

/** Astronomical unit (km) */
export const AU_KM = 149597870.7;

/** Astronomical unit (m) */
export const AU_M = 149597870700.0;

/** Stefan-Boltzmann constant (W/m^2/K^4) */
export const STEFAN_BOLTZMANN = 5.670374419e-8;

/** J2000 epoch as Julian Date */
export const J2000 = 2451545.0;

/** Seconds per day */
export const SECONDS_PER_DAY = 86400.0;

/** Days per Julian year */
export const DAYS_PER_JULIAN_YEAR = 365.25;

/** Pi */
export const PI = Math.PI;

/** Two pi */
export const TWO_PI = 2.0 * Math.PI;

/** Half pi */
export const HALF_PI = 0.5 * Math.PI;

/** Degrees to radians conversion factor */
export const DEG2RAD = Math.PI / 180.0;

/** Radians to degrees conversion factor */
export const RAD2DEG = 180.0 / Math.PI;

/**
 * Gravitational parameters (GM) in km^3/s^2.
 * Source: JPL planetary constants.
 */
export const GM = {
  Sun: 132712440018.0,
  Mercury: 22032.0,
  Venus: 324859.0,
  Earth: 398600.4418,
  Moon: 4902.8,
  Mars: 42828.37,
  Jupiter: 126686534.0,
  Saturn: 37931187.0,
  Uranus: 5793939.0,
  Neptune: 6836529.0,
} as const;

/**
 * Mean radii (km).
 */
export const RADIUS = {
  Sun: 695700.0,
  Mercury: 2439.7,
  Venus: 6051.8,
  Earth: 6371.0,
  Moon: 1737.4,
  Mars: 3389.5,
  Jupiter: 69911.0,
  Saturn: 58232.0,
  Uranus: 25362.0,
  Neptune: 24622.0,
} as const;

/**
 * NAIF body IDs used by SPICE/Horizons.
 */
export const NAIF = {
  Sun: 10,
  Mercury: 199,
  Venus: 299,
  Earth: 399,
  Moon: 301,
  Mars: 499,
  Jupiter: 599,
  Saturn: 699,
  Uranus: 799,
  Neptune: 899,
} as const;
